import { z } from "zod";

const activtyNoteSchema = z.object({
	id: z.string(),
	case_activity_id: z.string().nullable(),
	case_record_id: z.string().nullable(),
	case_record_user_id: z.string().nullable(),
	note: z.string().nullable(),
	medias: z.array(z.any()).nullable(),
	created_by: z.string().nullable(),
	created_at: z.string(),
	updated_at: z.string().nullable(),
});

export const activityNoteFormSchema = z.object({
	id: z.string().nullable().optional(),
	case_activity_id: z.string(),
	case_record_id: z.string().nullable(),
	note: z.string().min(1, "Note is required"),
	attachment: z.any().nullable(),
	share_with: z.any(),
});

export type ActivityNote = z.infer<typeof activtyNoteSchema>;
export type ActivityNoteFormSchema = z.infer<typeof activityNoteFormSchema>;
